import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../Components/baseUrl";
import Menu from "../Components/Menu";
import { toast } from "react-toastify";
import { TelegramShareButton, WhatsappShareButton } from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";

const Setting = () => {
    const navigate = useNavigate();
    const [unreadNotifs, setUnreadNotifs] = useState(null);
    const shareUrl = `مشتری عزیز از این پس می توانید در اپلیکیشن پایا از شرکت مربوطه و صدها شرکت دیگر به صورت مستقیم کالای خود را سفارش دهید.
    02167586
    B2n.ir/y56863`;
    let token;
    let user;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
        user = localStorage.getItem("user");
        user = JSON.parse(user);
    }
    useEffect(() => {
        document.title = "پایا | تنظیمات";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const logoutHandler = (e) => {
        let config = {
            url: `${baseUrl}/logout`,
            method: "POST",
        };
        axios(config)
            .then((res) => {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                navigate("/login");
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const copyHandler = (e) => {
        toast.success("کپی شد", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    useEffect(() => {
        let config = {
            url: `${baseUrl}/notification`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setUnreadNotifs(res.data?.data?.un_read_count);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    return (
        <div className="container">
            {showLogoutModal && (
                <div className="logout-modal">
                    <h2>خروج</h2>
                    <span className="ques">
                        آیا مایل به خروج از برنامه هستید؟
                    </span>
                    <div className="btns">
                        <button
                            onClick={() => setShowLogoutModal(false)}
                            className="stay"
                        >
                            می مانم
                        </button>
                        <button onClick={logoutHandler} className="exit">
                            خروج
                        </button>
                    </div>
                </div>
            )}
            <div className="setting-main">
                <div className="head">
                    <span className="titr">تنظیمات</span>
                    <div
                        className="head-row"
                        onClick={() => navigate("/panel/profile")}
                    >
                        <div className="d-flex-center">
                            <svg
                                width="53"
                                height="53"
                                viewBox="0 0 53 53"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="26.5"
                                    cy="26.5"
                                    r="26.5"
                                    fill="#D6E9FF"
                                />
                                <path
                                    d="M23 22C23 24.2091 24.7909 26 27 26C29.2091 26 31 24.2091 31 22C31 19.7909 29.2091 18 27 18"
                                    stroke="#2F80ED"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M20 31.9347C20 31.0743 20.5409 30.3068 21.3511 30.0175V30.0175C25.004 28.7128 28.996 28.7128 32.6489 30.0175V30.0175C33.4591 30.3068 34 31.0743 34 31.9347V33.2502C34 34.4376 32.9483 35.3498 31.7728 35.1818L30.8184 35.0455C28.2856 34.6837 25.7144 34.6837 23.1816 35.0455L22.2272 35.1818C21.0517 35.3498 20 34.4376 20 33.2502V31.9347Z"
                                    stroke="#2F80ED"
                                    strokeWidth="1.5"
                                />
                            </svg>
                            {user && (
                                <div className="user">
                                    <span className="name">
                                        {user.name} {user.family}
                                    </span>
                                    <span className="phone">{user.mobile}</span>
                                </div>
                            )}
                        </div>
                        <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="13" cy="13" r="13" fill="#EFF1F3" />
                            <path
                                d="M14.5 9L11.0149 11.7106C10.5001 12.111 10.5001 12.889 11.0149 13.2894L14.5 16"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>
                <div className="links">
                    <a onClick={() => navigate("/panel/reports")}>
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.34315 18.6569C6.46197 19.7757 7.88743 20.5376 9.43928 20.8463C10.9911 21.155 12.5997 20.9965 14.0615 20.391C15.5233 19.7855 16.7727 18.7602 17.6518 17.4446C18.3449 16.4072 18.7832 15.2262 18.9376 13.9974C19.0064 13.4494 18.5523 13 18 13H12.5C11.6716 13 11 12.3284 11 11.5V6C11 5.44772 10.5506 4.99356 10.0026 5.06242C8.77376 5.21683 7.59275 5.65513 6.55544 6.34824C5.23985 7.22729 4.21446 8.47672 3.60896 9.93853C3.00346 11.4003 2.84504 13.0089 3.15372 14.5607C3.22951 14.9417 3.33262 15.3152 3.46164 15.6783"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M14 4C14 3.44772 14.45 2.99268 14.9966 3.07131C15.5731 3.15423 16.1383 3.30896 16.6788 3.53284C17.5281 3.88463 18.2997 4.40024 18.9497 5.05025C19.5998 5.70026 20.1154 6.47194 20.4672 7.32122C20.691 7.86171 20.8458 8.4269 20.9287 9.00339C21.0073 9.55005 20.5523 10 20 10L15 10C14.4477 10 14 9.55228 14 9V4Z"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                />
                            </svg>
                            گزارشات
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                            <path
                                d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                stroke="black"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    <a onClick={() => navigate("/panel/notifications")}>
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.48211 3C9.4418 2.36786 10.591 2 11.8261 2C15.1878 2 17.9131 4.72522 17.9131 8.08696V10.1795C17.9131 11.2798 18.6221 12.2422 19.1857 13.1872C19.482 13.684 19.6522 14.2647 19.6522 14.8851C19.6522 16.488 18.507 17.8633 16.9193 18.0834C15.3426 18.3021 13.3724 18.522 11.8261 18.522C10.2797 18.522 8.3096 18.3021 6.73291 18.0834C5.1452 17.8633 4 16.488 4 14.8851C4 14.2647 4.1702 13.684 4.46647 13.1872C5.03006 12.2422 5.73914 11.2798 5.73914 10.1795V8.08696C5.73914 7.25578 5.90573 6.46351 6.20735 5.74173"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M14 20.834C13.5326 21.5369 12.7335 22.0002 11.8261 22.0002C10.9187 22.0002 10.1195 21.5369 9.65218 20.834"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            اعلان ها
                            {unreadNotifs && unreadNotifs !== 0 ? (
                                <span className="red-badge">
                                    {unreadNotifs}
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                            <path
                                d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                stroke="black"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    <a onClick={() => navigate("/panel/favorites")}>
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            علاقمندی ها
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                            <path
                                d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                stroke="black"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>

                    <a target={"_blank"} href="https://www.payacom.com/paya/">
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 4.11745V20.9906M12 4.11745L13.1001 3.70461C15.6036 2.76513 18.3964 2.76513 20.8999 3.70461C21.5643 3.95395 22 4.55769 22 5.22907V19.0797C22 20.0016 21.0075 20.632 20.0951 20.2896C18.1082 19.544 15.8918 19.544 13.9049 20.2896L12.0137 20.9993C12.0071 21.0018 12 20.9972 12 20.9906M12 4.11745L10.8999 3.70461C8.39638 2.76513 5.60362 2.76513 3.10014 3.70461C2.43569 3.95395 2 4.55769 2 5.22907V9.69174M12 20.9906C12 20.9972 11.9929 21.0018 11.9863 20.9993L10.0951 20.2896C8.10825 19.544 5.89175 19.544 3.90485 20.2896C2.99247 20.632 2 20.0016 2 19.0797V13.6171"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            راهنما
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                            <path
                                d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                stroke="black"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    <a
                        target={"_blank"}
                        href="https://www.payacom.com/%D8%AA%D9%85%D8%A7%D8%B3-%D8%A8%D8%A7-%D9%85%D8%A7-%D9%86%D8%B1%D9%85-%D8%A7%D9%81%D8%B2%D8%A7%D8%B1-%D9%BE%D8%AE%D8%B4-%D9%85%D9%88%DB%8C%D8%B1%DA%AF%DB%8C-%D9%BE%D8%A7%DB%8C%D8%A7/"
                    >
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.5 4H6C3.79086 4 2 5.79086 2 8V9.22305C2 9.41329 2.1354 9.57393 2.31525 9.63594C3.29568 9.97398 4 10.9047 4 12C4 13.0953 3.29568 14.026 2.31525 14.3641C2.1354 14.4261 2 14.5867 2 14.777V16C2 18.2091 3.79086 20 6 20H18C20.2091 20 22 18.2091 22 16V14.777C22 14.5867 21.8646 14.4261 21.6847 14.3641C20.7043 14.026 20 13.0953 20 12C20 10.9047 20.7043 9.97398 21.6847 9.63594C21.8646 9.57393 22 9.41329 22 9.22305V8C22 5.79086 20.2091 4 18 4H11"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M15 7L15 4"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M15 13.5L15 10.5"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M15 20L15 17"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            پشتیبانی
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                            <path
                                d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                stroke="black"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    <a>
                        <div>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.80849 8.40419C8.80849 10.2843 10.3326 11.8084 12.2127 11.8084C14.0929 11.8084 15.617 10.2843 15.617 8.40419C15.617 6.52408 14.0929 4.99994 12.2127 4.99994"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M6.25531 16.8594C6.25531 16.1271 6.71561 15.474 7.40517 15.2277V15.2277C10.5141 14.1174 13.9114 14.1174 17.0203 15.2277V15.2277C17.7099 15.474 18.1702 16.1271 18.1702 16.8594V17.9789C18.1702 18.9895 17.2751 19.7658 16.2747 19.6229L15.9412 19.5753C13.4681 19.222 10.9574 19.222 8.48436 19.5753L8.15081 19.6229C7.15038 19.7658 6.25531 18.9895 6.25531 17.9789V16.8594Z"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M17.3191 11.9027C18.7964 11.9027 19.9939 10.7051 19.9939 9.2279C19.9939 7.75067 18.7964 6.55313 17.3191 6.55313"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M20.2486 18.005L20.5107 18.0424C21.2968 18.1547 22 17.5448 22 16.7507V15.8711C22 15.2958 21.6384 14.7826 21.0966 14.5891C20.5561 14.396 20.0046 14.2457 19.4468 14.1381"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M6.68088 11.9027C5.20364 11.9027 4.0061 10.7051 4.0061 9.2279C4.0061 7.75067 5.20364 6.55313 6.68088 6.55313"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M3.75137 18.005L3.48929 18.0424C2.70324 18.1547 1.99997 17.5448 1.99997 16.7507V15.8711C1.99997 15.2958 2.36164 14.7826 2.90344 14.5891C3.44389 14.396 3.99543 14.2457 4.55316 14.1381"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            معرفی به دوستان
                            <TelegramShareButton
                                className="me-2"
                                url={shareUrl}
                            >
                                <svg
                                    className="ms-2"
                                    viewBox="0 0 64 64"
                                    width="24"
                                    height="24"
                                >
                                    <circle
                                        cx="32"
                                        cy="32"
                                        r="32"
                                        fill="#25A3E3"
                                    ></circle>
                                    <path
                                        d="m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
                                        fill="white"
                                    ></path>
                                </svg>
                            </TelegramShareButton>
                            <WhatsappShareButton url={shareUrl}>
                                <svg
                                    className="ms-2"
                                    viewBox="0 0 64 64"
                                    width="24"
                                    height="24"
                                >
                                    <circle
                                        cx="32"
                                        cy="32"
                                        r="32"
                                        fill="#25D366"
                                    ></circle>
                                    <path
                                        d="m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
                                        fill="white"
                                    ></path>
                                </svg>
                            </WhatsappShareButton>
                            <a
                                className="send-sms"
                                href="sms:?&body=https://my.payacom.com/"
                            >
                                <svg
                                    className="ms-2"
                                    viewBox="0 0 64 64"
                                    width="24"
                                    height="24"
                                >
                                    <circle
                                        cx="32"
                                        cy="32"
                                        r="32"
                                        fill="#7f7f7f"
                                    ></circle>
                                    <path
                                        d="M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </a>
                            <CopyToClipboard text={shareUrl}>
                                <button
                                    className="copy-btn"
                                    onClick={copyHandler}
                                >
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="copy"
                                        role="img"
                                        fill="#7d7d7d"
                                        width={14}
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                    >
                                        <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                                    </svg>
                                    کپی
                                </button>
                            </CopyToClipboard>
                        </div>
                    </a>
                    <a onClick={() => navigate("/panel/contact_us")}>
                        <div>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.90717 1.36067C5.00763 0.79874 3.82782 0.891832 3.06847 1.65118L1.7817 2.93795C-0.172609 4.89227 1.66372 9.89718 5.88327 14.1167C10.1028 18.3363 15.1077 20.1726 17.0621 18.2183L18.3488 16.9315C19.2371 16.0432 19.2137 14.5795 18.2964 13.6622L16.3033 11.6691C15.386 10.7518 13.9222 10.7283 13.0339 11.6166L12.7575 11.893C12.2779 12.3726 11.5042 12.4196 10.9641 11.9739C10.4432 11.544 9.92435 11.0806 9.42188 10.5781C8.9194 10.0756 8.45597 9.55679 8.0261 9.03587C7.58045 8.49581 7.62737 7.72209 8.10699 7.24247L8.38337 6.96609C9.08368 6.26578 9.21731 5.20785 8.79308 4.34197"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            تماس با ما
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                            <path
                                d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                stroke="black"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                    {/* <a id="sms_a">
                        <div
                            onclick="showSmsHandler()"
                            className="d-flex-center inner-a"
                        >
                            <div>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                ارسال پیامک غیر فعال
                            </div>
                            <svg
                                className="rot-svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="10" cy="10" r="10" fill="#EFF1F3" />
                                <path
                                    d="M11.1539 6.9231L8.70726 8.82605C8.19252 9.22641 8.19252 10.0044 8.70726 10.4048L11.1539 12.3077"
                                    stroke="black"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                        <button id="btn-a-1" className="d-none a-btn-green">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M2 16.5H8"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M2 12.5H5"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            ارسال پیامک
                        </button>
                        <button id="btn-a-2" className="d-none">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M2 16.5H8"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    opacity="0.4"
                                    d="M2 12.5H5"
                                    stroke="#04B900"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            ارسال پیامک فعال
                        </button>
                    </a> */}
                    <a onClick={() => setShowLogoutModal(true)}>
                        <div>
                            <svg
                                width="21"
                                height="22"
                                viewBox="0 0 21 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14 15V17C14 19.2091 12.2091 21 10 21H5C2.79086 21 1 19.2091 1 17V5C1 2.79086 2.79086 1 5 1H10C12.2091 1 14 2.79086 14 5V7"
                                    stroke="#EB5757"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M17 14L19.2929 11.7071C19.6834 11.3166 19.6834 10.6834 19.2929 10.2929L17 8"
                                    stroke="#EB5757"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M19 11L7 11"
                                    stroke="#EB5757"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            خروج از حساب
                        </div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#FFCECE" />
                            <path
                                d="M11.1539 6.92308L8.7072 8.82604C8.19246 9.22639 8.19246 10.0044 8.7072 10.4047L11.1539 12.3077"
                                stroke="#FF0000"
                                strokeLinecap="round"
                            />
                        </svg>
                    </a>
                </div>
                <Menu active="setting" />
            </div>
        </div>
    );
};

export default Setting;
